import axios, { AxiosInstance } from 'axios';
import { apiConfig } from '@/config/apiConfig';
import { getVoiceFallbackClient } from './_shared';

// ── Events (/api/events) ──────────────────────────────────────────────

/** `POST /api/events` — emit a client-side event to the pipeline. */
export async function emitVoiceEvent(event: { event_type: string; session_id?: string; payload?: Record<string, unknown> }, axiosInstance?: AxiosInstance): Promise<{ ok: boolean }> {
  const client = axiosInstance || getVoiceFallbackClient();
  await client.post(`${apiConfig.voiceEndpoints.events}`, event);
  return { ok: true };
}
